import { authHeader } from '../Helpers';
import { endpoints } from '../Constants';
import handleResponse from './helpers';

// Assembled-at-outlet boxes (Product.freshlyPrepared) - console2.0_be assembly.py.

// A box's standard contents per box (its recipe, packaging left out):
// data.recipe = [{variantId, productId, productName, unit, qtyPerBox}]
function fetchStandardRecipe(variantId) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			variantId,
		}),
	};
	return fetch(endpoints.ASSEMBLY_STANDARD_RECIPE, requestOptions).then(handleResponse);
}

const assemblyServices = {
	fetchStandardRecipe,
};

export default assemblyServices;
